import { useNavigate } from 'react-router-dom'
import { Home, ArrowLeft } from 'lucide-react'

export default function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-br from-cyber-900 to-cyber-700 flex items-center justify-center p-4">
      <div className="text-center space-y-6 max-w-md">
        {/* 404 */}
        <div>
          <h1 className="text-9xl font-bold text-white opacity-80">404</h1>
          <p className="text-3xl font-bold text-white mt-4">Page Not Found</p>
        </div>

        {/* Message */}
        <p className="text-white/80 text-lg">
          Sorry, we couldn't find the page you're looking for. It might have been moved or deleted.
        </p>

        {/* Buttons */}
        <div className="flex flex-col gap-3 pt-4">
          <button
            onClick={() => navigate('/')}
            className="btn-primary flex items-center justify-center space-x-2 py-3"
          >
            <Home size={20} />
            <span>Go to Dashboard</span>
          </button>
          <button
            onClick={() => navigate(-1)}
            className="btn-secondary flex items-center justify-center space-x-2 py-3"
          >
            <ArrowLeft size={20} />
            <span>Go Back</span>
          </button>
        </div>
      </div>
    </div>
  )
}
